<template>
  <div class="invoice-items-list text-grey-9">
    <q-input
      v-if="showHeadingInput"
      v-model="heading"
      :float-label="$t('invoice_block_heading')"
      class="q-mb-sm"
      hide-underline
    />

    <table class="line-items-table">
      <thead>
        <tr>
          <th></th>
          <th class="text-left">{{ $t('description') }}</th>
          <th class="text-right">{{ $t('quantity') }}</th>
          <th class="text-right">{{ $t('price') }}</th>
          <th v-if="hasDiscount" class="text-right">{{ $t('discount') }}</th>
          <th class="text-right">{{ $t('sales_tax') }}</th>
          <th class="text-right">{{ $t('sum_net') }}</th>
          <th></th>
        </tr>
      </thead>

      <draggable v-model="children" element="tbody" :options="{ group: 'items', handle: '.drag-item-handle' }">
        <line-items-table-row
          v-for="(lineItem, index) in lineItems.children"
          :key="`${index}-${lineItem.itemName}`"
          :lineItem="lineItem"
          :currency="currency"
          :showDiscount="hasDiscount"
          @remove="handleRemoveItem(index)"
          @update="handleUpdateItem(index, $event)"
        />
      </draggable>
    </table>

    <p v-if="lineItems.children.length === 0" class="text-center q-mt-md text-grey-6">
      {{ $t('line_items_empty_text') }}
    </p>

    <q-btn
      v-if="showDeleteButton"
      color="grey-8"
      size="sm"
      class="q-mt-sm"
      flat
      @click="handleRemoveBlock"
    >
      {{ $t('delete_line_item_group') }}
    </q-btn>
  </div>
</template>

<script>
  import LineItemsTableRow from './LineItemsTableRow.vue'
  import draggable from 'vuedraggable'

  export default {
    data () {
      return {
        lineItems: {
          type: 'group',
          heading: null,
          children: []
        }
      }
    },

    props: {
      value: {
        required: true,
        type: Object
      },

      currency: {
        required: true,
        type: String
      },

      showHeadingInput: {
        required: false,
        type: Boolean,
        default: true
      },

      showDeleteButton: {
        required: false,
        type: Boolean,
        default: true
      }
    },

    computed: {
      children: {
        get () {
          return this.lineItems.children
        },

        set (value) {
          this.$emit('updateGroup', value)
        }
      },

      hasDiscount () {
        return this.lineItems.children
          .filter((item) => item.discountAbsolute || item.discountRelative)
          .length > 0
      },

      heading: {
        get () {
          return this.lineItems.heading
        },

        set (value) {
          this.$emit('updateGroupHeading', value)
        }
      }
    },

    methods: {
      handleRemoveItem (index) {
        this.$emit('deleteItem', index)
      },

      handleUpdateItem (index) {
        this.$emit('update', this.lineItems.children[index])
      },

      handleRemoveBlock () {
        this.$q.dialog({
          title: this.$t('confirm'),
          message: this.$t('invoice_block_delete_confirm'),
          ok: this.$t('delete'),
          cancel: this.$t('cancel')
        }).then(() => {
          this.$emit('deleteBlock')
        }).catch(() => {})
      }
    },

    watch: {
      value () {
        if (this.value) {
          this.lineItems = this.value
        }
      }
    },

    created () {
      if (this.value) {
        this.lineItems = this.value
      }
    },

    components: {
      draggable,
      LineItemsTableRow
    }
  }
</script>

<style lang="stylus">
  @import '~variables'

  table.line-items-table
    width 100%
    border-collapse collapse

    thead > tr > th
        padding 4px 8px
        font-weight bold
        color 718096
        border-bottom 1px solid #A0AEC0

    tbody > tr > td
        padding 12px 8px
        border-bottom 1px solid #CBD5E0

    tbody > tr:nth-child(odd)
      background #F7FAFC

    td > .drag-item-handle
      cursor move
      cursor -webkit-grabbing

  .invoice-items-list
    .invoice-items-list__row
      margin-bottom: .5rem
      padding: .5rem
      background: $grey-2
      transition: background .5s
      &:hover
        background: $grey-3
      .invoice-items-list__item-description
        padding: 0 1rem;
</style>
